import styled from 'styled-components'

import Icon from '../components/Icon'
import media from '../util/media'

export const IconBadge = styled(Icon)`
  color: white;
  position: absolute;
  top: -40px;
  right: -20px;
  z-index: 2;

  ${media.lessThan('sm')`
    top: -20px;
    right: 40px;
    width: 80px;
    height: 80px;
  `}
`

export const IconCorn = styled(Icon)`
  position: absolute;
  bottom: -20px;
  right: -40px;

  ${media.lessThan('md')`
    right: -80px;
  `}

  ${media.lessThan('sm')`
    width: 80px;
    bottom: 40px;
    right: -10px;
  `}
`
